// This file was automatically generated and should not be edited.;
import type { SVGProps } from 'react';
import { Ref, forwardRef } from 'react';
const SvgFireFlame = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    ref={ref}
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M11.26 8.297a.75.75 0 0 1 .468.885c-.101.404-.165 1.138-.135 1.97.03.829.15 1.668.365 2.29.109.31.227.525.336.654.103.12.165.132.189.134.034.004.164.003.42-.17.259-.175.594-.492 1.005-1.02a.75.75 0 0 1 1.263.125c1.268 2.537 1.712 4.663 1.128 6.223-.627 1.677-2.28 2.362-4.299 2.362-1.141 0-2.316-.145-3.223-.707C7.8 20.438 7.25 19.427 7.25 18c0-3.202 1.427-6.043 2.826-8.83l.253-.505a.75.75 0 0 1 .931-.368m-1.069 4.08C9.349 14.249 8.75 16.055 8.75 18c0 .988.346 1.476.816 1.768.541.335 1.366.482 2.434.482 1.74 0 2.587-.565 2.895-1.388.3-.804.208-2.109-.596-4.012a4.4 4.4 0 0 1-.554.452c-.439.297-.918.472-1.415.42-.508-.052-.899-.325-1.18-.656-.273-.322-.467-.725-.608-1.132a8 8 0 0 1-.351-1.557"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12.406 2.37 12 3l-.406-.63a.75.75 0 0 1 .812 0M12 3.905a29.684 29.684 0 0 0-3.482 2.836c-.975.931-1.929 1.994-2.635 3.107-.71 1.118-1.133 2.231-1.133 3.277 0 2.337.69 4.093 1.883 5.267S9.617 20.25 12 20.25s4.174-.683 5.367-1.858c1.193-1.174 1.883-2.93 1.883-5.267 0-1.046-.424-2.159-1.133-3.277-.706-1.113-1.66-2.176-2.635-3.107A30 30 0 0 0 12 3.905m-.406-1.535L12 3l.406-.63.003.001.005.004.02.012.071.048q.094.06.264.179a31.195 31.195 0 0 1 3.749 3.043c1.025.978 2.071 2.135 2.865 3.387.79 1.246 1.367 2.642 1.367 4.081 0 2.634-.785 4.815-2.33 6.336S14.667 21.75 12 21.75s-4.876-.77-6.42-2.289c-1.545-1.521-2.33-3.702-2.33-6.336 0-1.44.576-2.835 1.367-4.08.794-1.253 1.84-2.41 2.865-3.389a31 31 0 0 1 4.013-3.221l.071-.048.02-.012.005-.004z"
      clipRule="evenodd"
    />
  </svg>
);
export const FireFlameIcon = forwardRef(SvgFireFlame);
